import React from "react";
import PropTypes from "prop-types";
import ErrorPage from "./ErrorPage";
import LoggedInUserErrorPage from "./LoggedInUserErrorPage";

const OopsPage = ({ error }) => {
  if (error.response && error.response.status === 403)
    return <LoggedInUserErrorPage />;
  return <ErrorPage />;
};

OopsPage.propTypes = {
  error: PropTypes.shape({
    response: PropTypes.shape({
      status: PropTypes.number,
    }),
  }).isRequired,
};

export default OopsPage;
